import { Button } from '@mui/material';
import { Formik } from 'formik';
import { useMemo } from 'react';
import { useMutation } from 'react-query';
import { useRecoilStateLoadable } from 'recoil';
import { useGetAllBusinessProductsQuery } from '../../../api/apigQuery';
import { IUserAtom, user } from '../../../recoil/atoms/user';
import { getApiMutation } from '../../../services/rest/getApiMutation';
import { endpointEnum } from '../../../services/rest/makeAPIRequest';
import { getPriceAndCycle } from '../../pages/ManageNumbers';
import { ModalWithStyles } from './ModalWithStyles';

export function BuyNumberConfirmationModal({
  show,
  handleClose,
  number,
  rate,
  methodNameEnum,
  makeRequest,
  enqueueSnackbarWithStyles,
  formikValues,
  handleCloseOuter,
  refetchBusinessNumbers,
  formik,
}) {
  const [userAtomLoadable, setUserAtom] = useRecoilStateLoadable(user);
  const userAtom = userAtomLoadable.contents as IUserAtom;
  const mutation = useMutation(getApiMutation(userAtom, setUserAtom));
  const businessSmsEnabled = process.env.VITE_APP_BUSINESS_SMS === '1';

  const { currentData: busProducts } = useGetAllBusinessProductsQuery({
    userSettings: {
      userId: userAtom?.userid,
      userid: userAtom?.userid,
      businessId: userAtom?.businessid,
      businessid: userAtom?.businessid,
      apikey: userAtom?.apikey,
    },
  });
  const productData = useMemo(() => {
    const d = busProducts ?? [];
    return {
      localLine: d?.filter((p) => p.product === 'localtrackingline')?.[0],
      tollFreeLine: d?.filter((p) => p.product === 'tollfreetrackingline')?.[0],
    };
  }, [busProducts]);
  const { price, billingCycle } = getPriceAndCycle(
    productData,
    formik.values?.numType
  );

  return (
    <Formik
      onSubmit={async (_, actions) => {
        let targetid = '';
        switch (formikValues.numberFor) {
          case 'None':
            targetid = '';
            break;
          case 'Agent':
            targetid = formikValues.agent;
            break;
          case 'Conference':
            targetid = formikValues.conference;
            break;
          case 'Queue':
            targetid = formikValues.queue;
            break;
          case 'Group':
            targetid = formikValues.group;
            break;
          case 'IVR':
            targetid = formikValues.ivr;
            break;
        }
        // console.log(targetid, 'this is the  target id we exrtacted');
        const { response } = await makeRequest({
          methodName: methodNameEnum.BUY_PHONE_NUMBER,
          payload: {
            targetid,
            country: formikValues.country,
            destinationType:
              formikValues.numberFor.toLocaleLowerCase() === 'agent'
                ? 'user'
                : formikValues.numberFor.toLocaleLowerCase().replace(/\s/g, ''),
            number,
            rate,
            numType:
              formikValues.numType.toLocaleLowerCase() === 'local'
                ? 'fixed'
                : formikValues.numType.toLocaleLowerCase(),
            numberName: formikValues.numberName,
            defaultUserId: userAtom?.userid, //ENG-6833: pass the purchaser userid as the default userid
            role: userAtom?.user?.role,
          },
        });
        if (response.data.success === 'true') {
          enqueueSnackbarWithStyles({
            message: `Successfully Purchased the Number - ${number}`,
            alertProps: { severity: 'success' },
          });
          if (
            businessSmsEnabled &&
            formikValues?.businessSMSId &&
            formikValues?.businessSMSId !== '' &&
            formikValues.numberFor.toLocaleLowerCase() !== 'agent'
          ) {
            const data = {
              call: methodNameEnum.EDIT_NUMBER2,
              apikey: userAtom?.apikey,
              businessid: userAtom?.businessid,
              destinationid: response?.data?.new?.destinationid,
              type: response?.data?.new?.type,
              defaultuser: response?.data?.new?.defaultuser ?? 'none',
              numberid: response?.data?.new?.Numberid,
              numberName: response?.data?.new?.numberName,
              businessSMSId: formikValues?.businessSMSId,
            };
            const res = await mutation.mutateAsync({
              endpoint: endpointEnum.EDIT_NUMBER2,
              payload: data,
            });
            if (!res?.data?.success) {
              enqueueSnackbarWithStyles({
                message: `Encountered an error adding team SMS to the ${number.DID} number`,
                alertProps: { severity: 'warning' },
              });
            }
          }
        } else {
          enqueueSnackbarWithStyles({
            message: response?.data?.message
              ? response.data.message
              : 'Encountered An Error while trying to purchase Number',
            alertProps: { severity: 'warning' },
          });
        }
        // console.log(response, 'response of buying the actual number');
        formik.resetForm({});
        actions.resetForm({});
        refetchBusinessNumbers();
        handleClose();
        handleCloseOuter();
      }}
      enableReinitialize={true}
      initialValues={{
        number,
        rate,
      }}
    >
      {(formik) => (
        <ModalWithStyles
          title={`Buy Number - ${number} `}
          aria-labelledby="example-modal-sizes-title-lg"
          show={show}
          onHide={handleClose}
          isLoading={formik.isSubmitting}
          size="xs"
          onSubmit={formik.handleSubmit}
          footerComponent={
            <>
              <Button
                disabled={formik.isSubmitting}
                variant="contained"
                disableElevation={true}
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                color="primary"
                variant="contained"
                disableElevation={true}
                disabled={formik.isSubmitting}
                onClick={formik.handleSubmit as any}
              >
                Yes
              </Button>
            </>
          }
        >
          <p>
            {`You are about to add a new Kixie Number ${number} to your account.`}
          </p>
          <p>
            {`You will be charged $${
              price * billingCycle
            } instantly and a new product in the amount of
            $${price} per ${billingCycle === 1 ? '' : billingCycle} month${
              billingCycle === 1 ? '' : 's'
            } will be applied to your next invoice.`}
          </p>
          <p>Are you sure you want to continue?</p>
        </ModalWithStyles>
      )}
    </Formik>
  );
}
